import DateHelper from "../../../services/DateHelper";

class CancelDetails {

  constructor(data) {
    this.cancellation = new CancelDues(data.cancellation);
    // this.member_cancel_details = new MemberCancelDetails(cancelDetails.member_cancel_details);
    // this.club_cancel_details = new ClubCancelDetails(cancelDetails.club_cancel_details);
    this.reduce_rate = data.reduce_rate ? new ReduceRateOffer(data.reduce_rate) : null;
    this.downgrade = data.downgrade ? new DowngradeOffer(data.downgrade) : null;
    this.free_addon = data.free_addon ? new AddonOffer(data.free_addon) : null;
    this.upgrade = data.upgrade ? new UpgradeOffer(data.upgrade) : null;
  }

}

export const CancellationPeriodType = {
  CooldownPeriod: 'Cooldown Period',
  MandatoryPeriod: 'Mandatory Period',
  NoticePeriod: 'Notice Period',
}

export const CancellationPaymentTypes = {
  Now: "now",
  Regular: "regular",
};

class CancelDues {
  active_until;
  annual_fee;
  allow_regular_payment;
  full_refund;
  dues_payment;
  processing_fee_payment;
  final_payment;
  outstanding_balance;
  notice_period;
  mandatory_period;
  cooldown_period;
  error;
  invoices;
  type;
  buyout_conditions;
  draft_pending;
  has_recurring_services;

  constructor(data) {
    Object.assign(this, data);
  }

  getInvoiceToPay() {
    return (this.invoices || []).concat(
      this.buyout_conditions ? this.buyout_conditions.invoices : []
    )
  }

  hasBuyoutFee() {
    return this.buyout_conditions && this.buyout_conditions.is_buyout_fee;
  }

  getBuyoutPrice() {
    return this.hasBuyoutFee() ? this.buyout_conditions.total : 0;
  }

  getBuyoutDues() {
    return this.buyout_conditions && !this.hasBuyoutFee() ? this.buyout_conditions.total : 0;
  }

  getDuesPayment() {
    return this.dues_payment + this.getBuyoutDues();
  }

  getFinalAmount(isPayNow) {
    return this.outstanding_balance + this.getDuesPayment() + this.annual_fee + this.getBuyoutPrice() + this.getProcessingFeeAmount(isPayNow);
  }

  getProcessingFeeAmount(isPayNow) {
    const invoices_total = (this.invoices || []).length + (this.buyout_conditions ? this.buyout_conditions.invoices.length : 0);
    return isPayNow ? this.processing_fee_payment : invoices_total * this.processing_fee_payment;
  }

  getNoticeDays () {
    return this.getLength(this.notice_period);
  }

  getMandatoryDays () {
    return this.getLength(this.mandatory_period);
  }

  getCooldownDays () {
    return this.getLength(this.cooldown_period);
  }

  formattedCooldownEnd (startDate) {
    const date = DateHelper.createDate(startDate);
    date.setDate(date.getDate() + this.getLength(this.cooldown_period));
    return date.toLocaleDateString();
  }

  getLength(seconds) {
    return Math.round(seconds / (3600 * 24));
  }

  hasDues() {
    return this.getFinalAmount() > 0;
  }

  formattedActiveUntil () {
    const activeUntil = this.buyout_conditions ? this.buyout_conditions.active_until : this.active_until;
    const date = DateHelper.createDate(activeUntil);
    return date.toLocaleDateString();
  }

  isCooldownPeriod() {
    return this.type === CancellationPeriodType.CooldownPeriod
  }

  hasPendingPayment() {
    return this.draft_pending;
  }

  hasRecurringServices() {
    return this.has_recurring_services;
  }
}

class DowngradeOffer {
  constructor(data) {
    Object.assign(this, data);
  }
}

class UpgradeOffer {
  constructor(data) {
    Object.assign(this, data);
  }
}

class AddonOffer {
  constructor(data) {
    Object.assign(this, data);
  }
}

class ReduceRateOffer {
  constructor(data) {
    this.numberOfMonths = data.number_of_months;
    this.discount = data.discount;
  }
}

export default CancelDetails;